import axios from './axios';

export const fetchCosmetics = async (type) => {
    const params = type ? { type } : {};
    const response = await axios.get('/cosmetics', { params });
    return response.data;
};

export const fetchMyCosmetics = async () => {
    const response = await axios.get('/cosmetics/mine');
    return response.data;
};

export const setCosmetic = async ({ type, mode, cosmeticID }) => {
    const response = await axios.put('/users/setCosmetic', { type, mode, cosmeticID });
    return response.data;
};
